var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepingbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 87C21.1125 87 9 74.8875 9 60C9 45.1125 21.1125 33 36 33V39C24.42 39 15 48.42 15 60C15 71.58 24.42 81 36 81V87Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87H36V81H84C95.58 81 105 71.58 105 60C105 48.42 95.58 39 84 39H36V33H84C98.8875 33 111 45.1125 111 60C111 74.8875 98.8875 87 84 87Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.395 46.8775C48.3825 41.8725 42.4075 39 36 39V33C44.2375 33 51.92 36.69 57.0775 43.1225L52.395 46.875V46.8775Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8775 81.0775L49.125 76.395C54.13 72.3825 57.0025 66.4075 57.0025 60C57.0025 55.1725 55.41 50.635 52.3975 46.8775L57.08 43.125C60.9 47.89 63.0025 53.8825 63.0025 60.0025C63.0025 68.24 59.3125 75.9225 52.88 81.08L52.8775 81.0775Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87V81C40.8275 81 45.365 79.4075 49.125 76.395L52.8775 81.0775C48.1125 84.8975 42.12 87 36 87Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87V81C74.58 81 84 71.58 84 60C84 54.66 81.095 49.915 78.66 46.8775L83.3425 43.125C87.7 48.56 90.0025 54.395 90.0025 60.0025C90.0025 74.89 77.89 87.0025 63.0025 87.0025L63 87Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87C21.1125 87 9 74.8875 9 60C9 45.1125 21.1125 33 36 33V39C24.42 39 15 48.42 15 60C15 71.58 24.42 81 36 81V87Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6675 75C27.1325 75 21 68.9525 21 61.5175C21 55.24 26.175 50.1325 32.5325 50.1325C37.84 50.1325 42 54.4675 42 60H36C36 58.125 34.785 56.1325 32.5325 56.1325C29.4825 56.1325 27 58.5475 27 61.5175C27 65.6425 30.44 69 34.6675 69C40.365 69 45 64.4675 45 58.8975C45 55.145 43.4525 51.6675 40.645 49.1075L44.6875 44.6725C48.7 48.33 51 53.515 51 58.8975C51 67.775 43.6725 75 34.6675 75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepingbag);
export default __webpack_public_path__ + "static/media/Sleepingbag.3a145d41.svg";
export { ForwardRef as ReactComponent };